import * as $ from 'jquery';

import {Global} from '../init-global';
import 'slick-carousel';

require('jquery-debounced-and-throttled-resize/jquery.debouncedresize.js');



export class ProductVariants {

    protected $root:JQuery;
    protected isMobile: boolean;
    protected carouselActive:boolean = false;
    protected breakpoint:number = 640;
    protected $list:JQuery;


    constructor(elem: HTMLElement)
    {
        this.$root = $(elem);
        this.bindUI();
    }

    private bindUI = () => {
    	this.$list = $('.l-product-variations__list', this.$root);

        // Set starting state according to layout mode
        this.refreshViewport();

        // Watch the viewport for size changes
        $(window).on('debouncedresize', () => this.refreshViewport());
    }

    private initDesktop = () => {
        if (this.carouselActive) {
        	this.$list.slick('unslick');
        	this.carouselActive = false;
        }
    }

    private initMobile = () => {
       	this.initCarousel();
    }

    private initCarousel = () => {
    	console.log(Math.floor(this.$list.children().length / 2));
    	this.$list.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 800,
            rows: 0,
            arrows: false,
            centerMode: true,
            infinite: false,
            initialSlide: Math.floor(this.$list.children().length / 2),
  			centerPadding: '70px',
  			responsive: [
            {
              breakpoint: 640,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '60px',
                slidesToShow: 2
              }
            },
            {
              breakpoint: 450,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '70px',
                slidesToShow: 1
              }
            }
          ]
        });
        this.carouselActive = true;
    }

    private refreshViewport = () => {
        let vp = Global.getViewport();
        let dspForMobile:boolean = (vp.width < this.breakpoint) ? true: false;

        if (dspForMobile != this.isMobile) {
            this.isMobile = dspForMobile;
            (this.isMobile) ? this.initMobile(): this.initDesktop();
        }
    }
}